<template>
    <div class="play-back-item">
        <!-- <div v-for="(item, index) in itemData" :key="index" class="item-content">
            <h3>
                <p class="date">{{ date(index) }}</p>
                <p class="week">{{ date(index) }}</p>
            </h3>
        </div> -->
        <replay :replayData="itemData"></replay>
    </div>
</template>

<script>
import Replay from '@components/playBackList/Replay';
export default {
    components: {
        Replay
    },
    props: {
        itemData: {
            require: true,
            type: Object
        }
    },
    data() {
        return {};
    },
    created() {},
    mounted() {},
    methods: {}
};
</script>
<style lang="scss" scoped>
/* @import url(); 引入css类 */
</style>
